import React, { useEffect, useState } from "react";
import { decryptData, encryptData } from "../../utils/storage";
import { useNavigate, useParams } from "react-router-dom";
import { clearStepValues, RestfullApiService } from "../../config/service";
import toast from "react-hot-toast";
import cart from "../../assets/img/icons/cart.png";
import LoginForm from "../auth/LoginForm";
import EmailForm from "../auth/EmailForm";
// import { Tooltip, tooltipClasses } from "@mui/material";
import PreLoader from "../../utils/PreLoader";
import { inrCurrency, removeSpace } from "../../utils";
import { useSelector } from "react-redux";

function EventCategory() {
  const { event_id } = useParams();
  // const { isLoggedIn } = useAuth();
  // const user = JSON.parse(localStorage.getItem("userProf"));
  const user = useSelector((state) => state.user.userProfile);
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const isVerified =
    (user?.Is_Email_Verified && user?.Is_Mobile_Verified) ||
    (user?.Is_Google_Verified && user?.Is_Mobile_Verified);

  const navigate = useNavigate();
  const [eventDetails, setEventDetails] = useState();
  const [categories, setCategories] = useState();
  const [toggleCoupon, setToggleCoupon] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [discountApplied, setDiscountApplied] = useState(false);

  const [isBooking, setIsBooking] = useState(false);
  const [isUserLoggedIn, setUserLoggedIn] = useState(false);
  const [showLoginForm, setShowLoginForm] = useState(false);
  const [showEmailForm, setShowEmailForm] = useState(false);
  const [fetchingDetails, setFetchingDetails] = useState(false);

  const bookEvent = async (categories) => {
    const discountDetails = JSON.parse(localStorage.getItem("discountDetails"));

    const reqdata = {
      Method_Name: "Step0",
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
      Participant_Id: user?.Participant_Id,
      Booking_Id: "",
      Event_Id: decryptData(event_id),
      XMLData: "",
      Coupon_Code: discountDetails?.Discount_Id ?? "",
    };
    try {
      setIsBooking(true);
      const result = await RestfullApiService(
        reqdata,
        "participant/book_event"
      );
      if (result) {
        localStorage.setItem(
          "Booking_Id",
          result?.data?.Result?.Table1[0]?.Result_Extra_Key
        );
        localStorage.setItem(
          "Mandatory_Fields",
          JSON.stringify(
            result?.data?.Result?.Table2?.map((field) => field.Question_Id)
          )
        );
        navigate(`/event-user-details/${event_id}`, { replace: true });
        return result;
      }
    } catch (err) {
      if (err?.Result?.Table1[0]?.Result_Description) {
        toast.error(err?.Result?.Table1[0]?.Result_Description);
      } else {
        toast.error(err?.message);
      }
    } finally {
      setIsBooking(false);
    }
  };
  const handleCount = (id, action) => {
    setCategories((prevCategories) => {
      const selectedCategories = prevCategories.map((category) => {
        if (category.EventCategory_Id === id) {
          let newCount = category.count;
          switch (action) {
            case "increase":
              if (newCount < 10) {
                newCount += 1;
              }
              break;
            case "decrease":
              newCount = Math.max(newCount - 1, 0);
              break;
            default:
              return category;
          }
          return { ...category, count: newCount };
        }
        return category;
      });
      localStorage.setItem(
        "selectedCategories",
        JSON.stringify(selectedCategories)
      );

      return prevCategories.map((category) => {
        if (category.EventCategory_Id === id) {
          let newCount = category.count;
          switch (action) {
            case "increase":
              if (newCount < 10) {
                newCount += 1;
              }
              break;
            case "decrease":
              newCount = Math.max(newCount - 1, 0);
              break;
            default:
              return category;
          }
          return { ...category, count: newCount };
        }
        return category;
      });
    });
  };
  const handleToggleCoupon = () => {
    setToggleCoupon(!toggleCoupon);
  };
  const applyCouponCode = async (coupon) => {
    const Event_Id = decryptData(event_id);
    // const user = JSON.parse(localStorage.getItem("userProf"));
    localStorage.setItem("beforeDiscountAmount", totalAmount);

    const reqdata = {
      Method_Name: "Apply",
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: user?.First_Name + " " + user?.Last_Name,
      Event_Id: Event_Id,
      Total_Amount: totalAmount,
      Coupon_Code: coupon?.promoCode,
      Booking_Id: "",
    };
    try {
      const result = await RestfullApiService(reqdata, "participant/discount");
      if (result) {
        console.log(result?.data);

        const discount = result?.data?.Result?.Table1[0];

        if (discount?.DiscountType_Name === "Percent Based") {
          const discountAmount =
            (discount?.Total_Event_Price * discount?.Discount_Value) / 100;
          const afterDiscountAmount =
            discount?.Total_Event_Price - discountAmount;

          console.log(`Discount Amount: ${discountAmount}`);
          console.log(`Amount After Discount: ${afterDiscountAmount}`);
          localStorage.setItem("discountDetails", JSON.stringify(discount));
          localStorage.setItem("discountAmount", discountAmount);
          localStorage.setItem("afterDiscountAmount", afterDiscountAmount);
          setTotalAmount(afterDiscountAmount);
          setDiscountAmount(discountAmount);
        }

        setDiscountApplied(true);
      }
    } catch (err) {
      toast.error(err?.Result?.Table1[0]?.Result_Description);
    }
  };
  const removeCouponCode = async () => {
    const beforeDiscountAmount = localStorage.getItem("beforeDiscountAmount");

    try {
      setTotalAmount(beforeDiscountAmount);
      localStorage.removeItem("discountDetails");
      localStorage.removeItem("discountAmount");
      localStorage.removeItem("afterDiscountAmount");
      setDiscountAmount(0);
      setToggleCoupon(false);
    } catch (err) {
      console.log(err);
    } finally {
      setDiscountApplied(false);
    }
  };
  async function loadEvent(Event_Id) {
    const reqdata = {
      Method_Name: "Category",
      Month: "",
      Sport_Id: "",
      City_Id: "",
      Event_Id: Event_Id,
      SearchBy: "",
    };
    try {
      setFetchingDetails(true);
      const result = await RestfullApiService(
        reqdata,
        "participant/event_list"
      );
      if (result) {
        setEventDetails(result?.data?.Result?.Table2[0]);
        return result;
      }
    } catch (err) {
      toast.error(err);
    } finally {
      setFetchingDetails(false);
    }
  }
  useEffect(() => {
    const discountDetails = JSON.parse(localStorage.getItem("discountDetails"));
    const discountAmount = localStorage.getItem("discountAmount");
    if (discountDetails && discountAmount) {
      const newTotal = categories?.reduce((sum, category) => {
        if (category?.Is_Flat_discount_valid === "Y") {
          return sum + category?.Discount_Value_Category * category?.count;
        } else {
          return sum + category?.Event_Price * category?.count;
        }
      }, 0);
      localStorage.setItem("beforeDiscountAmount", newTotal);
      if (discountDetails?.DiscountType_Name === "Percent Based") {
        const newDiscountAmount =
          (newTotal * discountDetails?.Discount_Value) / 100;
        const afterDiscountAmount = newTotal - newDiscountAmount;

        console.log(`Discount Amount: ${discountAmount}`);
        console.log(`Amount After Discount: ${afterDiscountAmount}`);
        localStorage.setItem("discountAmount", newDiscountAmount);
        localStorage.setItem("afterDiscountAmount", afterDiscountAmount);
        setTotalAmount(afterDiscountAmount);
        setDiscountAmount(newDiscountAmount);
      }
      return;
    }
    const newTotal = categories?.reduce((sum, category) => {
      console.log(category);
      if (category?.Is_Flat_discount_valid === "Y") {
        return sum + category?.Discount_Value_Category * category?.count;
      } else {
        return sum + category?.Event_Price * category?.count;
      }
    }, 0);
    setTotalAmount(newTotal);
  }, [categories]);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    clearStepValues();
    // const user = JSON.parse(localStorage.getItem("userProf"));
    async function fetchEventCategories() {
      const decrypted = decryptData(event_id);
      const response = await loadEvent(decrypted);
      const alreadySelected = JSON.parse(
        localStorage.getItem("selectedCategories")
      );

      if (alreadySelected) {
        console.log(alreadySelected);
        setCategories(alreadySelected);
        return;
      }

      if (response) {
        console.log(response?.data?.Result);

        const mappedCategories = response?.data?.Result?.Table1?.map(
          (category) => {
            return { ...category, count: 0 };
          }
        );
        console.log(mappedCategories);

        setCategories(mappedCategories);
      }
    }
    if (event_id) {
      fetchEventCategories();
    }
    if (user) {
      setUserLoggedIn(true);
    } else {
      console.log(user);
      setUserLoggedIn(false);
    }
  }, [event_id, isLoggedIn]);
  // , isLoggedIn, user
  return (
    <>
      {fetchingDetails && <PreLoader />}
      {!fetchingDetails && (
        <>
          <section
            style={{ marginTop: "80px" }}
            className="py-6 d-flex items-center bg-blue-1-05"
          >
            <div className="container">
              <div className="row y-gap-10 items-center justify-between">
                <div className="col-auto">
                  <div className="row x-gap-10 y-gap-5 items-center text-14 font-inter fw-500 text-light-1">
                    <div className="col-auto">
                      <a href="/" className="cursor-pointer">
                        Home
                      </a>
                    </div>
                    <div className="col-auto">
                      <div className="">{">"}</div>
                    </div>
                    <div className="col-auto">
                      <div
                        className="cursor-pointer"
                        onClick={() => navigate("/event/list")}
                      >
                        Events
                      </div>
                    </div>
                    <div className="col-auto">
                      <div className="">{">"}</div>
                    </div>
                    <div className="col-auto">
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          const encryptedParam = encryptData(
                            eventDetails?.Event_Id
                          );
                          navigate(
                            `/event-details/${removeSpace(
                              eventDetails?.Event_Name
                            )}/${encryptedParam}`
                          );
                        }}
                      >
                        Events Details
                      </div>
                    </div>
                    <div className="col-auto">
                      <div className="">{">"}</div>
                    </div>
                    <div className="col-auto">
                      <div className="text-primary">Event Categories</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="pt-20">
            <div className="container">
              <div className="row y-gap-20 justify-between items-end border-bottom-light">
                <div className="col-auto">
                  <div className="row x-gap-20  items-center">
                    <div className="col-auto">
                      <h1 className="text-22 sm:text-20 fw-600">
                        {eventDetails?.Display_Name}
                      </h1>
                      <div className="row x-gap-20 font-inter">
                        <div className="col-auto">
                          <div className="text-left d-flex items-center py-10 x-gap-10">
                            <i className="fas fa-map-marker-alt text-20 fw-600 text-primary"></i>
                            <div className="text-14 fw-600 lh-1 text-reading">
                              {eventDetails?.City_Name}, {eventDetails?.State}
                            </div>
                          </div>
                        </div>
                        <div className="col-auto">
                          <div className="text-left d-flex items-center py-10 x-gap-10">
                            <i className="far fa-calendar text-18 fw-600 text-primary"></i>
                            <div className="text-14 fw-600 lh-1 text-reading">
                              {eventDetails?.Start_Date}
                            </div>
                          </div>
                        </div>
                        <div className="col-auto">
                          <div className="text-left d-flex items-center py-10 x-gap-10">
                            <i className="far fa-clock text-18 fw-600 text-primary"></i>
                            <div className="text-14 fw-600 lh-1 text-reading">
                              {eventDetails?.Start_Time} Onwards
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="pt-30 layout-pb-md">
            {/* {showLoginForm ? (
          <LoginForm />
        ) : ( */}
            <div className="container">
              <div className="row y-gap-30">
                <div className="col-xl-7">
                  <div className="row y-gap-30">
                    <div className="col-xl-12 col-lg-12 col-sm-12">
                      {showLoginForm ? (
                        showEmailForm ? (
                          <EmailForm
                            setShowEmailForm={setShowEmailForm}
                            setShowLoginForm={setShowLoginForm}
                          />
                        ) : (
                          <LoginForm
                            setShowEmailForm={setShowEmailForm}
                            setShowLoginForm={setShowLoginForm}
                          />
                        )
                      ) : (
                        categories?.length > 0 &&
                        categories?.map((category, index) => {
                          return (
                            <div
                              key={category.EventCategory_Id}
                              className={`border-light rounded-100 px-30 py-15 lg:rounded-20 -hover-shadow${
                                index !== 0 ? " mt-20" : ""
                              }`}
                            >
                              <div className="eventsCard__content">
                                <div className="row items-center justify-between">
                                  <div className="col-xl-9 col-lg-9 col-sm-6 font-inter">
                                    <h4 className="eventsCard__title text-dark-1 text-14 lh-13 fw-600">
                                      <a href="#">
                                        <span>
                                          {category?.EventCategory_Name}
                                        </span>
                                      </a>
                                    </h4>
                                    <div className="d-flex items-center gap-5 mt-5">
                                      <div className="fw-600 text-14 text-reading">
                                        {/* ₹ {category?.Event_Price} */}
                                        {category?.Is_Flat_discount_valid ===
                                        "Y" ? (
                                          <>
                                            <s className="ml-5">
                                              ₹{" "}
                                              {category?.Event_Price?.toFixed(
                                                2
                                              )}
                                            </s>{" "}
                                            <span>
                                              ₹{"  "}
                                              {category?.Discount_Value_Category?.toFixed(
                                                2
                                              )}
                                            </span>
                                          </>
                                        ) : (
                                          `₹ ${category?.Event_Price?.toFixed(
                                            2
                                          )}`
                                        )}
                                      </div>
                                      {category?.Is_Ticket_Avaliable ===
                                      "Sold Out" ? (
                                        <p
                                          className="fw-600 text-14"
                                          style={{ color: "#FF1414" }}
                                        >
                                          ({category?.Is_Ticket_Avaliable})
                                        </p>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-xl-3 col-lg-3 col-sm-6">
                                    {/* ||
                                  !category?.count */}
                                    {category?.count === 0 ? (
                                      category?.Is_Ticket_Avaliable ===
                                      "Sold Out" ? (
                                        <button
                                          disabled
                                          className="button w-full -sm rounded-25 text-12 px-10 py-15"
                                        >
                                          SOLD OUT
                                        </button>
                                      ) : (
                                        <button
                                          onClick={() =>
                                            handleCount(
                                              category.EventCategory_Id,
                                              "increase"
                                            )
                                          }
                                          className="button w-full -sm border-primary -primary-1 text-primary rounded-25 text-14 fw-600 px-10 py-15 add-button"
                                        >
                                          ADD
                                        </button>
                                      )
                                    ) : (
                                      <div className="d-flex items-center js-counter rounded-25 border-primary justify-center">
                                        <button
                                          onClick={() =>
                                            handleCount(
                                              category.EventCategory_Id,
                                              "decrease"
                                            )
                                          }
                                          className="button text-primary size-38 m-child minus"
                                        >
                                          <i className="fas fa-minus text-12"></i>
                                        </button>

                                        <div className="flex-center size-30 ml-5 mr-5">
                                          <div className="text-15">
                                            <input
                                              className="text-center fw-600 increase-btn"
                                              type="number"
                                              value={category.count}
                                              id="1"
                                              minLength="1"
                                              maxLength="2" // limit input length to 2 to prevent inputs like "100"
                                              autoComplete="off"
                                              onChange={(e) => {
                                                e.preventDefault();
                                                const { value } = e.target;

                                                // Regular expression to allow only numbers
                                                const regex = /^[1-9]\d*$/;

                                                if (
                                                  !value ||
                                                  (regex.test(value) &&
                                                    Number(value) <= 10)
                                                ) {
                                                  setCategories(
                                                    (prevCategories) => {
                                                      const selectedCategories =
                                                        prevCategories.map(
                                                          (cat) => {
                                                            console.log(cat);
                                                            if (
                                                              cat.EventCategory_Id ===
                                                              category.EventCategory_Id
                                                            ) {
                                                              console.log(
                                                                "match"
                                                              );
                                                              console.log(
                                                                value
                                                              );
                                                              console.log(
                                                                typeof value
                                                              );
                                                              return {
                                                                ...cat,
                                                                count:
                                                                  Number(value),
                                                              };
                                                            }
                                                            return cat;
                                                          }
                                                        );

                                                      localStorage.setItem(
                                                        "selectedCategories",
                                                        JSON.stringify(
                                                          selectedCategories
                                                        )
                                                      );

                                                      return selectedCategories;
                                                    }
                                                  );
                                                } else {
                                                  return;
                                                }
                                              }}
                                              // disabled
                                              style={{
                                                backgroundColor: "transparent",
                                              }}
                                            />
                                          </div>
                                        </div>

                                        <button
                                          onClick={() =>
                                            handleCount(
                                              category.EventCategory_Id,
                                              "increase"
                                            )
                                          }
                                          className="button text-primary size-38 p-child plus"
                                        >
                                          <i className="fas fa-plus text-12"></i>
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-xl-5">
                  <div className="ml-50 lg:ml-0">
                    {categories?.length > 0 &&
                    categories?.every((category) => category.count === 0) ? (
                      <div className="px-15 py-30 border-light rounded-16 empty-card">
                        <div className="d-flex justify-center mt-10 js-lazy">
                          <img src={cart} alt="cart" width="200" />
                        </div>
                        <p className="text-16 text-primary fw-600 text-center">
                          No Item Added
                        </p>
                      </div>
                    ) : (
                      <div className="px-45 lg:px-20 py-15 border-light rounded-16 price-card">
                        <h3 className="text-16 fw-600">SUMMARY</h3>
                        {/* <div className="d-flex mt-25 mb-10 js-lazy items-center justify-between font-inter">
                          <div className="text-13 lh-14 fw-500 text-reading">
                            Price ({" "}
                            {categories?.reduce(
                              (sum, category) => sum + category.count,
                              0
                            )}{" "}
                            {categories?.reduce(
                              (sum, category) => sum + category.count,
                              0
                            ) === 1
                              ? "item"
                              : "items"}{" "}
                            )
                          </div>
                          <div className="text-15 lh-14 fw-500 text-reading">
                            {totalAmount ? inrCurrency(totalAmount) : 0}
                          </div>
                        </div> */}
                        {categories
                          ?.filter((cat) => cat?.count !== 0)
                          ?.map((category, index) => {
                            return (
                              <div
                                className={`d-flex mt-10 ${
                                  index ===
                                  categories?.filter((cat) => cat?.count !== 0)
                                    ?.length -
                                    1
                                    ? "mb-25"
                                    : "mb-10"
                                } js-lazy items-start justify-between font-inter`}
                              >
                                <div className="d-flex flex-column gap-5">
                                  <div className="text-13 lg:text-12 lh-14 fw-500 text-reading">
                                    {category?.EventCategory_Name}
                                  </div>
                                  <div className="text-13 lg:text-12 lh-14 fw-500 text-reading">
                                    {/* ( {inrCurrency(category?.Event_Price)} x{" "}
                                    {category?.count}{" "}
                                    {category?.count === 1 ? "item" : "items"} ) */}
                                    {category?.Is_Flat_discount_valid === "Y"
                                      ? `( ${inrCurrency(
                                          category?.Discount_Value_Category?.toFixed(
                                            2
                                          )
                                        )} x${" "}
                                    ${category?.count}${" "}
                                    ${
                                      category?.count === 1 ? "item" : "items"
                                    } )`
                                      : `( ${inrCurrency(
                                          category?.Event_Price?.toFixed(2)
                                        )} x${" "}
                                    ${category?.count}${" "}
                                    ${
                                      category?.count === 1 ? "item" : "items"
                                    } )`}
                                  </div>
                                </div>
                                <div className="text-15 lg:text-14 lh-14 fw-500 text-reading">
                                  {category?.Is_Flat_discount_valid === "Y"
                                    ? inrCurrency(
                                        (
                                          category?.count *
                                          category?.Discount_Value_Category
                                        ).toFixed(2)
                                      )
                                    : inrCurrency(
                                        (
                                          category?.count *
                                          category?.Event_Price
                                        ).toFixed(2)
                                      )}
                                </div>
                              </div>
                            );
                          })}

                        <div
                          className="mt-10 mb-20 js-lazy border-top-light d-flex items-start justify-between border-bottom-light font-inter"
                          style={{ padding: "22px 0" }}
                        >
                          <div>
                            <h4 className="text-14 fw-600 mb-5">
                              Total Amount
                            </h4>
                            <p className="text-13 fw-500 text-reading">
                              Excluding taxes
                            </p>
                          </div>
                          <div className="text-22 lh-14 fw-600 text-primary">
                            {totalAmount
                              ? inrCurrency(totalAmount?.toFixed(2))
                              : 0}
                          </div>
                        </div>
                        <div className="row y-gap-10 text-center font-inter">
                          {/* <p className="text-reading text-14">
                            “Offers Only For Limited Tickets”
                          </p> */}
                          <div className="col-12 relative">
                            <button
                              disabled={isBooking}
                              onClick={() => {
                                // if (!isUserLoggedIn) {
                                console.log(user, isLoggedIn, isVerified);
                                if (!isLoggedIn && !isVerified) {
                                  window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                  });
                                  setShowLoginForm(true);
                                  return;
                                }
                                bookEvent(categories);
                              }}
                              className={`button w-full h-50 px-20 -grey-1 bg-primary text-white rounded-25 load-button`}
                            >
                              {!isBooking && "Proceed"}
                              {isBooking && <span class="btn-spinner"></span>}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* // )} */}
          </section>
        </>
      )}
    </>
  );
}

export default EventCategory;

// {
/* <div className="d-flex mt-10 mb-25 js-lazy items-center justify-between font-inter">
                      <div className="text-13 lh-14 fw-500 text-reading">
                        Discount
                      </div>
                      <div
                        className="d-flex items-center"
                        style={{ gap: "8px" }}
                      >
                        {discountApplied && (
                          <Tooltip
                            title={
                              <span
                                // className="d-flex items-center is-menu-opened-hide lg:d-none"
                                style={{
                                  fontFamily: "Montserrat, sans-serif",
                                  letterSpacing: "0.05em",
                                }}
                              >
                                Remove Discount?
                              </span>
                            }
                            // placement="top"
                            slotProps={{
                              popper: {
                                sx: {
                                  [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                                    {
                                      marginTop: "0px",
                                    },
                                  [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                                    {
                                      marginBottom: "0px",
                                    },
                                  [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                                    {
                                      marginLeft: "0px",
                                    },
                                  [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                                    {
                                      marginRight: "0px",
                                    },
                                },
                              },
                            }}
                          >
                            <i
                              className="fas fa-plus text-12 text-error-2 pointer"
                              style={{ rotate: "45deg" }}
                              onClick={() => {
                                removeCouponCode();
                              }}
                            ></i>
                          </Tooltip>
                        )}

                        <div className="text-13 lh-14 fw-500 text-reading">
                          ₹ {discountAmount ? discountAmount : 0}
                        </div>
                      </div>
                    </div> */
// }
// {
/* <div className="accordion -simple row y-gap-20 js-accordion font-inter">
                      <div
                        className="col-12 pb-0"
                        style={{ paddingBottom: "0px !important" }}
                      >
                        <div
                          className={`accordion__item border-top-light ${
                            toggleCoupon && "is-active"
                          }`}
                          style={{ padding: "22px 0" }}
                        >
                          <div className="accordion__button d-flex items-center justify-between">
                            <div className="button text-14 fw-600">
                              Apply Coupon Code
                            </div>
                            <img
                              src={badge}
                              alt="badge"
                              width="20"
                              onClick={() => {
                                if (!user) {
                                  toast.error(
                                    "Please Login to apply coupon code",
                                    {
                                      style: {
                                        backgroundColor: "red",
                                        color: "#fff",
                                      },
                                      icon: "⚠️",
                                    }
                                  );
                                  return;
                                }
                                handleToggleCoupon();
                              }}
                            />
                          </div>

                          <div
                            className={`accordion__content ${
                              toggleCoupon ? "accordion__max_h" : ""
                            }`}
                          >
                            <Formik
                              initialValues={{ promoCode: "" }}
                              validationSchema={Yup.object().shape({
                                promoCode: Yup.string().required(
                                  "Promo code is required"
                                ),
                              })}
                              onSubmit={(values) => {
                                applyCouponCode(values);
                              }}
                            >
                              {({ handleChange, handleBlur, handleSubmit }) => (
                                <Form onSubmit={handleSubmit}>
                                  <div className="pt-20">
                                    <div className="single-field relative d-flex justify-end items-center">
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "5px",
                                          width: "100%",
                                        }}
                                      >
                                        <input
                                          name="promoCode"
                                          className="bg-white rounded-8 border-primary"
                                          type="text"
                                          placeholder="Apply Promo Code"
                                          onChange={handleChange}
                                        />
                                        <ErrorMessage
                                          name="promoCode"
                                          component="div"
                                          className="text-error-2 text-13"
                                        />
                                      </div>
                                      <button className="absolute px-15 py-12 text-15 fw-400 text-white bg-primary rounded-right-8">
                                        Apply
                                      </button>
                                    </div>
                                  </div>
                                </Form>
                              )}
                            </Formik>
                          </div>
                        </div>
                      </div>
                    </div> */
// }
